<script lang="ts">
	import { Image } from "@unpic/svelte";
	import { ImagePlaceholder } from "flowbite-svelte-v1";
	import { twMerge } from "tailwind-merge";
	import { Mode } from "#gen/bundles/v1/service_pb.js";
	import DataToken from "#lib/components/DataToken.svelte";
	import { TokenProvider } from "#lib/tokenProvider.js";

	interface Props {
		provider?: TokenProvider;
		src?: string;
		mode: Mode;
		imgClass?: string;
		badgeClass?: string;
		placeholderClass?: string;
	}

	const { provider = new TokenProvider(), src, imgClass, badgeClass, placeholderClass, mode }: Props = $props();

	let imageLoadError = $state(false);

	$effect(() => {
		if (src) {
			imageLoadError = false;
		}
	});
</script>

{#snippet placeholder()}
	<ImagePlaceholder size="sm" imgOnly={true} class="h-full w-full animate-none" classes={{ image: "h-full sm:w-full w-full bg-gray-100 m-0", svg: twMerge("text-gray-400", placeholderClass) }} />
{/snippet}

<div class={imgClass}>
	{#if src && !imageLoadError}
		{#if mode === Mode.EDITING && provider.hasSubstitutionToken(src)}
			{@render placeholder()}
			{#if provider.getSubstitutionToken(src)}
				{@const token = provider.getSubstitutionToken(src)}
				<div class="absolute top-4 right-4">
					<DataToken provider={token?.provider} label={token?.label ?? ""} class={twMerge("pointer-events-none mr-0", badgeClass)} />
				</div>
			{/if}
		{:else}
			<Image {src} class="absolute inset-0 h-full w-full object-cover" alt="Asset image" onerror={() => (imageLoadError = true)} />
		{/if}
	{:else}
		{@render placeholder()}
	{/if}
</div>
